import * as React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import { useDataProvider } from "react-admin";
import { Tabs, Tab, Box } from "@material-ui/core";
import { useState } from "react";
import { SourceQuarantineDetailList } from "./Constant/Source";
import QuarantineDetail from "./QuarantineDetail";
import { QuarantineReasons } from "../../Enums/QuarantineReasons";
import { QuarantineStatusType } from "../../../src/Enums/QuarantineStatusType";

const useStyles = makeStyles({
  root: { width: "100%", margin: "auto" },
  spacer: { height: 20 },
});

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const QuarantineListDetail = (props: any) => {
  const provider = useDataProvider();
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };
  const [noXo, setNoXo] = useState([] as any);
  const [noWebSuite, setnoWebSuite] = useState([] as any);
  const [notIc, setNotIc] = useState([] as any);
  const [alreadyExist, setAlreadyExist] = useState([] as any);
  const [noUsTag, setNoUsTag] = useState([] as any);
  const [unmatchedPnSn, setUnmatchedPnSn] = useState([] as any);
  const [lastOh, setLastOh] = useState([] as any);
  const [hcInfo, setHcInfo] = useState([] as any);
  const [damageMissingPart, setDamageMissingPart] = useState([] as any);
  const [other, setOther] = useState([] as any);

  React.useEffect(() => {
    provider
      .getList(SourceQuarantineDetailList, {
        pagination: { page: 1, perPage: 999 },
        sort: { field: "id", order: "DESC" },
        filter: { quarantineId__eq: props.id },
      })
      .then(response => {
        if (response.data.length > 0) {
          setnoWebSuite(
            response.data.filter(t => {
              return t.quarantineReasonId == QuarantineReasons.NoWebSuite;
            })
          );
          setNoXo(
            response.data.filter(t => {
              return t.quarantineReasonId == QuarantineReasons.NoXo;
            })
          );
          setNotIc(
            response.data.filter(t => {
              return t.quarantineReasonId == QuarantineReasons.NotIC;
            })
          );
          setAlreadyExist(
            response.data.filter(t => {
              return t.quarantineReasonId == QuarantineReasons.AlreadyExists;
            })
          );
          setNoUsTag(
            response.data.filter(t => {
              return t.quarantineReasonId == QuarantineReasons.NoUsTag;
            })
          );
          setUnmatchedPnSn(
            response.data.filter(t => {
              return t.quarantineReasonId == QuarantineReasons.UnmatchedPnSn;
            })
          );
          setLastOh(
            response.data.filter(t => {
              return t.quarantineReasonId == QuarantineReasons.LastOhIsMissing;
            })
          );
          setHcInfo(
            response.data.filter(t => {
              return t.quarantineReasonId == QuarantineReasons.FHCInfoMissing;
            })
          );
          setDamageMissingPart(
            response.data.filter(t => {
              return t.quarantineReasonId == QuarantineReasons.DamageMissingPart;
            })
          );
          setOther(
            response.data.filter(t => {
              return t.quarantineReasonId == QuarantineReasons.Other;
            })
          );
        }
      })
      .catch(error => {});
  }, [props]);

  return (
    <Card className={classes.root}>
      <CardContent>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Quarantine Detail"
          variant="fullWidth"
          indicatorColor="primary"
        >
          <Tab
            fullWidth
            label="NO WEB SUITE"
            {...a11yProps(0)}
            style={
              noWebSuite.filter(t => {
                return t.quarantineReasonStatus == QuarantineStatusType.Open;
              }).length > 0
                ? { background: "#FFC300" }
                : { background: "green" }
            }
          />
          <Tab
            fullWidth
            label="No XO"
            {...a11yProps(1)}
            style={
              noXo.filter(t => {
                return t.quarantineReasonStatus == QuarantineStatusType.Open;
              }).length > 0
                ? { background: "#FFC300" }
                : { background: "green" }
            }
          />
          <Tab
            fullWidth
            label="Not I/C"
            {...a11yProps(2)}
            style={
              notIc.filter(t => {
                return t.quarantineReasonStatus == QuarantineStatusType.Open;
              }).length > 0
                ? { background: "#FFC300" }
                : { background: "green" }
            }
          />
          <Tab
            fullWidth
            label="Already Exist"
            {...a11yProps(3)}
            style={
              alreadyExist.filter(t => {
                return t.quarantineReasonStatus == QuarantineStatusType.Open;
              }).length > 0
                ? { background: "#FFC300" }
                : { background: "green" }
            }
          />
          <Tab
            fullWidth
            label="No US Tag"
            {...a11yProps(4)}
            style={
              noUsTag.filter(t => {
                return t.quarantineReasonStatus == QuarantineStatusType.Open;
              }).length > 0
                ? { background: "#FFC300" }
                : { background: "green" }
            }
          />
          <Tab
            fullWidth
            label="Unmatched PN-SN"
            {...a11yProps(5)}
            style={
              unmatchedPnSn.filter(t => {
                return t.quarantineReasonStatus == QuarantineStatusType.Open;
              }).length > 0
                ? { background: "#FFC300" }
                : { background: "green" }
            }
          />
          <Tab
            fullWidth
            label="Last OH is missing"
            {...a11yProps(6)}
            style={
              lastOh.filter(t => {
                return t.quarantineReasonStatus == QuarantineStatusType.Open;
              }).length > 0
                ? { background: "#FFC300" }
                : { background: "green" }
            }
          />
          <Tab
            fullWidth
            label="F. H/C Info Missing"
            {...a11yProps(7)}
            style={
              hcInfo.filter(t => {
                return t.quarantineReasonStatus == QuarantineStatusType.Open;
              }).length > 0
                ? { background: "#FFC300" }
                : { background: "green" }
            }
          />
          <Tab
            fullWidth
            label="Damage/Missing Part"
            {...a11yProps(8)}
            style={
              damageMissingPart.filter(t => {
                return t.quarantineReasonStatus == QuarantineStatusType.Open;
              }).length > 0
                ? { background: "#FFC300 " }
                : { background: "green" }
            }
          />
          <Tab
            fullWidth
            label="Other"
            {...a11yProps(9)}
            style={
              other.filter(t => {
                return t.quarantineReasonStatus == QuarantineStatusType.Open;
              }).length > 0
                ? { background: "#FFC300" }
                : { background: "green" }
            }
          />
        </Tabs>
        <TabPanel value={value} index={0}>
          <QuarantineDetail data={noWebSuite} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <QuarantineDetail data={noXo} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <QuarantineDetail data={notIc} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <QuarantineDetail data={alreadyExist} />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <QuarantineDetail data={noUsTag} />
        </TabPanel>
        <TabPanel value={value} index={5}>
          <QuarantineDetail data={unmatchedPnSn} />
        </TabPanel>
        <TabPanel value={value} index={6}>
          <QuarantineDetail data={lastOh} />
        </TabPanel>
        <TabPanel value={value} index={7}>
          <QuarantineDetail data={hcInfo} />
        </TabPanel>
        <TabPanel value={value} index={8}>
          <QuarantineDetail data={damageMissingPart} />
        </TabPanel>
        <TabPanel value={value} index={9}>
          <QuarantineDetail data={other} />
        </TabPanel>
      </CardContent>
    </Card>
  );
};

export default QuarantineListDetail;
